import { useState } from "react";
import { AlertProps } from "types";
import { useTranslation } from "react-i18next";

const useErrors = () => {
  const { t } = useTranslation("common");
  const [errors, setErrors] = useState<AlertProps[]>([]);

  const addAlert = (error: AlertProps) => {
    setErrors([...errors, error]);
  };

  const closeError = (index: number) => {
    setErrors(errors.splice(index, 1));
  };

  const closeAllErrors = () => {
    setErrors([]);
  };

  const handleError = (e: any) => {
    const { graphQLErrors, networkError } = e;

    if (graphQLErrors) {
      graphQLErrors.forEach((error: any) =>
        addAlert({
          title: error.message,
          description: error.extensions?.detailed_errors
            ? error.extensions.detailed_errors.join("\n")
            : "",
        })
      );
    }
    if (networkError) {
      // TODO: display real message from networkError
      addAlert({
        title: t("Error"),
        description: t("Please try again"),
      });
    }
    if (!graphQLErrors && !networkError) {
      if (e?.message) {
        addAlert({
          title: t("Error"),
          description: e?.message,
        });
      } else {
        addAlert({
          title: t("Error"),
          description: t("Please try again"),
        });
      }
    }
  };

  return {
    errors,
    handleError,
    closeError,
    closeAllErrors,
  };
};

export default useErrors;
